import { gql } from "@apollo/client";

export const ALL_MODAL_ACCCESS_SETTINGS = gql`
  query AllModalAccessSettings{
    AllModalAccessSettings {
      modalAccessSettings {
        id
        updatedAt
        createdAt
        feature
        type
        usersArray
        userIDName{
          label
          value
        }
       
      }
    }
  }
`;

// Scoped to the current user — returns only the feature keys they can access.
// Safe to call from the global Sidebar (no org-wide entitlement data exposed).
export const MY_MODULE_FEATURES = gql`
  query MyModuleFeatures {
    myModuleFeatures
  }
`;

export const SAVE_MODAL_ACCESS_SETTINGS = gql`
  mutation SaveModalAccessSettings($settingDetails: settingDetailsInput!) {
    SaveModalAccessSettings( settingDetails: $settingDetails) {
      message
      status
    }
  }
`;